import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import PageHeader from "../../../../../../../components/PageHeader";
import EmptyState from "../../../../../../../components/EmptyState";
import useRoutePlant from "../../../../../../../hooks/useRoutePlant";

export default function MRVPage() {
  const { mrvId } = useParams();
  const { plant } = useRoutePlant();

  return (
    <Box>
      <PageHeader
        plant={plant}
        pageTitle="Material Receipt Voucher (MRV)"
        moduleKey="mrv"
      />
      <Box sx={{ p: 2 }}>
        <EmptyState
          moduleKey="mrv"
          title={mrvId ? `MRV #${mrvId}` : "Material Receipt Voucher"}
          description="The receipt details page is on its way. Received quantities are recorded against the PO in the meantime."
        />
      </Box>
    </Box>
  );
}
